import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractDocumentationAggregate.Save.IRequest;
type Response = Api.Core.ContractDocumentationAggregate.Save.IResponse;
type Headers = Api.Core.ContractDocumentationAggregate.Save.IHeaders;
const url = '/api/Sales/Contract/:id/DocumentationAggregate';
export default async function contractDocumentationAggregateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.contractId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
